import React from "react";
import { useTranslation } from "react-i18next";

const ExtensiveWritingContent = () => {
  const { t } = useTranslation();
  return (
    <p className="chat-typing">
      {t("chat_mensaje_espera")}
      <span>.</span> <span>.</span> <span>.</span>
    </p>
  );
};

export default ExtensiveWritingContent;
